import { render } from "./ObjectiveSelect.vue?vue&type=template&id=3367c156"
import script from "./ObjectiveSelect.vue?vue&type=script&lang=js"
export * from "./ObjectiveSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__